import React, { Fragment } from 'react';
import Grid from '@material-ui/core/Grid';

import { Paper } from '@material-ui/core';

export default function CantFind() {
    return (
        <Fragment>
            <h1>This page is missing</h1>
            <Paper>
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justify="center"
                    style={{ minHeight: '25vh' }}
                ><Grid item xs={12} md={12} lg={12}>
                        <img src="/a44.gif" alt="These are not the droids" />
                        <br />
                        <br />
                    </Grid>
                </Grid>
            </Paper>
        </Fragment>
    )
}
